import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList } from "vue"

import { isExternal } from '@/utils/validate.js'
import AppLink from './Link.vue'
import path from 'path'
import { ref, computed } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarItem',
  props: {
  item: {
    type: Object,
    required: true
  },
  basePath: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props

const onlyOneChild = ref(null)
const hasOneShowingChild = (children = [], parent) => {
  const showingChildren = children.filter(item => {
    // 过滤掉需要隐藏的菜单
    if (item.hidden) {
      return false
    } else {
      // 临时设置（如果只有一个显示子项，则将使用）
      onlyOneChild.value = item
      return true
    }
  })
  // 当只有一个子路由器时，默认情况下会显示该子路由器
  if (showingChildren.length === 1) {
    return true
  }
  // 如果没有要显示的子路由器，则显示父路由器
  if (showingChildren.length === 0) {
    onlyOneChild.value = { ...parent, path: '', noShowingChildren: true }
    return true
  }

  return false
}


const resolvePath = (routePath) => {
  if (isExternal(routePath)) {
    return routePath
  }
  if (isExternal(props.basePath)) {
    return props.basePath
  }
  return path.resolve(props.basePath, routePath)
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_sidebar_item = _resolveComponent("sidebar-item", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!

  return (!__props.item.hidden)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (hasOneShowingChild(__props.item.children, __props.item))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (onlyOneChild.value.meta)
                ? (_openBlock(), _createBlock(AppLink, {
                    key: 0,
                    to: resolvePath(onlyOneChild.value.path)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: resolvePath(onlyOneChild.value.path)
                      }, {
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(onlyOneChild.value.meta && onlyOneChild.value.meta.title), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { size: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(__props.item.meta.icon)))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["index"])
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createBlock(_component_el_sub_menu, {
              key: 1,
              index: resolvePath(__props.item.path),
              "popper-class": "sub-menu"
            }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, { size: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(__props.item.meta.icon)))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("span", null, _toDisplayString(__props.item.meta && __props.item.meta.title), 1)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (child) => {
                  return (_openBlock(), _createBlock(_component_sidebar_item, {
                    key: child.path,
                    item: child,
                    "base-path": resolvePath(child.path)
                  }, null, 8, ["item", "base-path"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["index"]))
      ], 64))
    : _createCommentVNode("", true)
}
}

})